import { LibCategories, waitForConsent } from "src/utils/consent";
import { registerHandler } from "../handler";
import getStore from "src/utils/redux/store";
import { trackTask } from "src/utils/monitoring/events/tasks";
import uuid from "uuid";
import { setUserProperties } from "src/utils/redux/slices/userData";

declare const window: Window & {
  tkrc: any;
};

const TRAACKR_CLIENT_ID = "fd899b046c8e488f";

export default function registerHandlers() {
  registerHandler("purchase", async ({ order, plan, promoCode }) => {
    waitForConsent([LibCategories.targetingCookies]).then(async () => {
      const task = trackTask("trackTraakrPurchase");
      const store = getStore();
      const { userData } = store.getState();
      const orderIds = userData?.traakrOrderIds || [];
      const currentTraakrOrderId = uuid.v4();
      const updatedOrderIds = [...orderIds, currentTraakrOrderId];
      try {
        task.start();
        await window.tkrc.event("Purchase", {
          transactionId: currentTraakrOrderId,
          value: order.eltv_13_months,
          valueCurrency: "USD",
          products: [
            {
              id: plan.braintree_id,
              quantity: 1,
            },
          ],
          promoCode: promoCode.promoCodeApplied,
          clientId: TRAACKR_CLIENT_ID,
        });
        await store.dispatch(
          setUserProperties({ traakrOrderIds: updatedOrderIds })
        );
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });

  registerHandler("purchaseIntent", async ({ estimatedValue }) => {
    waitForConsent([LibCategories.targetingCookies]).then(async () => {
      const task = trackTask("trackTraakrPurchaseIntent");
      const store = getStore();
      const { userData } = store.getState();
      const orderIds = userData?.traakrOrderIds || [];
      const currentTraakrOrderId = uuid.v4();
      const updatedOrderIds = [...orderIds, currentTraakrOrderId];
      try {
        task.start();
        await window.tkrc.event("Purchase", {
          transactionId: currentTraakrOrderId,
          value: estimatedValue,
          valueCurrency: "USD",
          clientId: TRAACKR_CLIENT_ID,
        });
        await store.dispatch(
          setUserProperties({ traakrOrderIds: updatedOrderIds })
        );
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });
}
